module.exports = __webpack_public_path__ + "img/cliqueEmail.b2cce349.png";